import { render, staticRenderFns } from "./MplsOverInternet.vue?vue&type=template&id=c06d97d0&"
import script from "./MplsOverInternet.vue?vue&type=script&lang=js&"
export * from "./MplsOverInternet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports